import React from 'react';
import { motion } from 'framer-motion';
import { caseStudies } from '../data/portfolio';
import { Label } from './Label';
export function SelectedEvidence() {
  return <section id="cases" aria-labelledby="cases-heading" className="scroll-mt-20 bg-ink-800 px-6 py-24 md:px-10 md:py-32" data-id="element-191" data-mp="3p6tbqwrdgrd7">
      <div className="mx-auto w-full max-w-edge" data-id="element-192" data-mp="3gb3u8yt1oh53">
        <div className="grid gap-10 lg:grid-cols-12" data-id="element-193" data-mp="3gac5a6tydhns">
          <div className="lg:col-span-4" data-id="element-194" data-mp="3bdv9cqgihz05">
            <Label data-id="element-195" data-mp="3bapl1dfpj15h">Selected Evidence</Label>
          </div>
          <div className="lg:col-span-8" data-id="element-196" data-mp="36d7l2cjo3w9m">
            <h2 id="cases-heading" className="font-display text-3xl font-normal leading-[1.14] text-paper md:text-[3.25rem]" data-id="element-197" data-mp="31ew8vv5wh9o8">
              Judgement in action
            </h2>
            <p className="mt-7 max-w-2xl text-base leading-relaxed text-stone md:text-lg" data-id="element-198" data-mp="zo1b4xs4v0ev">
              Four board situations where investment, transaction and governance work met.
            </p>
          </div>
        </div>

        <ol className="mt-20 grid gap-y-16 md:mt-24 md:grid-cols-2 md:gap-x-16" data-id="element-199" data-mp="2qbv74xmwo1ey">
          {caseStudies.map((study, index) => <motion.li key={study.company} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: index % 2 * 0.05
        }} className="border-t border-white/20 pt-8" data-id="element-200" data-mp="2v9wmb7h7ngl5" data-mpi={index}>
              <p className="text-[0.8rem] uppercase tracking-[0.2em] text-fog" data-id="element-201" data-mp="3e1z78v0vxj17">{study.context}</p>
              <h3 className="mt-5 font-display text-3xl font-normal leading-tight text-paper md:text-[2.25rem]" data-id="element-202" data-mp="30aassl35yih2">
                {study.company}
              </h3>
              <p className="text-gradient mt-4 font-display text-xl italic leading-snug md:text-2xl" data-id="element-203" data-mp="3s1qemcwwc168">
                {study.headline}
              </p>
              <ul className="mt-7 space-y-3" data-id="element-204" data-mp="ovvgjwhh1oe">
                {study.points.map(point => <li key={point} className="border-t border-white/10 pt-3 text-[0.95rem] leading-relaxed text-paper/85" data-id="element-205" data-mp="airwgflv12r5">
                    {point}
                  </li>)}
              </ul>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}